import { memo } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import { ThemedFilePen } from "assets/CXFIcons/Actions";

const ButtonNotes = ({ type = "", isFromMenu = false, placement, handleOpenNoteDialog }) => {
  const { isVerticalCanvasDirection } = useSelector((state) => state?.designer?.settings);
  const { t } = useTranslation("flowDesigner");

  return (
    <Tooltip
      title={t("buttons.node_notes")}
      placement={isFromMenu ? placement || "bottom-start" : "left"}
    >
      <IconButton
        size="small"
        className={
          isFromMenu
            ? ""
            : `custom-node-notes-button ${isVerticalCanvasDirection ? "vertical" : ""} ${type}`
        }
        onClick={handleOpenNoteDialog}
      >
        <ThemedFilePen width="20px" height="20px" color="currentColor" />
      </IconButton>
    </Tooltip>
  );
};

export default memo(ButtonNotes);
